import { Component, OnInit, HostListener } from "@angular/core";
import { authenticationService } from "./login/auth.service";
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError,
} from "@angular/router";
import { Subject } from "rxjs";
import { ToastrService } from "ngx-toastr";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit {
  title = "app";
  isLogin: boolean;
  isAuthPage = false;

  userActivity;
  userInactive: Subject<any> = new Subject();
  userInactiveWarning: Subject<any> = new Subject();

  // Only show the route loader if navigation takes longer than this many
  // milliseconds, so quick navigations don't cause a flicker.
  private readonly routeLoaderDelayMs = 150;
  private routeLoadTimer: any;

  constructor(
    private router: Router,
    private authService: authenticationService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {
    this.setTimeout();
    this.userInactiveWarning.subscribe(
      () => (this.userActivity = setTimeout(() => this.displayWarn()))
    );
    this.userInactive.subscribe(() => this.logout());
  }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.isAuthPage = event.url === "/login" || event.url === "/reset";

        // Show a loader while a lazy-loaded module, guards, or resolvers
        // are still in flight. Auth pages are excluded.
        if (!this.isAuthPage) {
          this.routeLoadTimer = setTimeout(
            () => this.spinner.show("routeLoader"),
            this.routeLoaderDelayMs
          );
        }
      } else if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        clearTimeout(this.routeLoadTimer);
        this.spinner.hide("routeLoader");
      }
    });
  }

  displayWarn() {
    if (this.router.url != "/login") {
      this.toastr.warning("You will soon be logged out for inactivity.", "Alert!", {
        closeButton: true,
        enableHtml: true,
      });
      this.userActivity = setTimeout(
        () => this.userInactive.next(undefined),
        1 * 60 * 1000 // 1 minute
      );
    }
  }

  logout() {
    this.toastr.warning("Logged out due to inactivity.", "Alert!", {
      closeButton: true,
      enableHtml: true,
    });
    this.authService.logout();
  }

  setTimeout() {
    if (this.router.url != "/login") {
      this.userActivity = setTimeout(
        () => this.userInactiveWarning.next(undefined),
        5 * 1000 * 60 * 60 // 5 hours
      );
    }
  }

  @HostListener("window:mousemove") refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }
}
